import { graphql } from '../../graphql';

export const getProfileUserCards = graphql(`
  query ProfileUserCards {
    cards {
      id
      expiry
      issuer
      name
      pan
      isActive
      isExpired
      isPrimary
      system
      iconUrl
      token
    }
  }
`);
